import type { Locale } from '@ps-smart-cp/ppfw-client';
import { ItemName } from '@ps-smart-cp/ppfw-client';

function createDepreciationMethod(itemName: ItemName, suffix: string) {
  if (!suffix || itemName.displayName.size === 0) {
    return itemName;
  }
  const items = itemName.displayName.entries();
  const list: [Locale, string][] = Array.from(items).map((item) => [item[0], `${item[1]}(${suffix})`]);

  return ItemName.of(...list);
}

export { createDepreciationMethod };
